import { BUSERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import busersTypes from '../../constants/busersTypes'
import { axios } from '../../services'

//  lock AND unlock AND resend

const resend_buser_request = () => {
  return {
    type: busersTypes.resend.request
  }
}

const resend_buser_success = (response) => {
  return {
    type: busersTypes.resend.success,
    payload: response.data
  }
}

const resend_single_buser_success = (response) => {
  return {
    type: busersTypes.resend.single,
    payload: response.data
  }
}

const resend_buser_failure = (messages) => {
  return {
    type: busersTypes.resend.failure,
    payload: messages
  }
}

const resend_b2b_invitation = (buser_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( resend_buser_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(BUSERS_ROUTES.resend, {id: buser_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'A new invitation has been sent.')
      if ( index ) {
        dispatch( resend_buser_success(response) )

      } else {
        dispatch( resend_single_buser_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error resending invitation"]
        // errors = [error]
      }
      dispatch( resend_buser_failure( errors ) )
    })
  }
}

export {
  resend_b2b_invitation,
}



// WEBPACK FOOTER //
// ./src/js/actions/busers/resend.js